<template lang="pug">
  y-dialog(v-if="showModal" v-model="showModal" scrollable max-width="900px" persistent :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card
      v-card-title.px-4.h6.basic800--text
        v-btn.mr-3(icon small  @click="close")
          v-icon(color="basic800" :size="24") mdi-close
        div {{ title }}
      v-divider.basic300
      v-card-text.pa-0
        v-window(v-model="step")
          //- Company-tiers setup
          v-window-item(:value="0")
            company-tiers(ref="companyTiers" :companyTiers="companyTiers" :isNew="isNew")
          //- Product-tiers setup
          v-window-item(:value="1")
            product-tiers(ref="productTiers" :companyTiers="companyTiers" :isLoading.sync="isLoading" :edited.sync="edited")
          //- Reseller-tiers setup
          v-window-item(:value="2")
            member-tiers(ref="memberTiers" :companyTiers="companyTiers" :isLoading.sync="isLoading" :edited.sync="edited")

      v-card-actions.pa-4.justify-center(v-if="!(viaProductTiers || viaMemberTiers)")
        v-btn(depressed color='textColorAccent' block :loading="isLoading" :disabled="disableNext" @click="nextStep")
          template(v-if="step < 2")
            .button-AA-medium.basic100--text {{$t('next')}} : {{ nextText }}
          template(v-else)
            .button-AA-medium.basic100--text {{$t('finish')}}
      .modals
</template>

<script>
import CompanyTiers from '@/components/resellers/companyTiers/CompanyTiers.vue'
import ProductTiers from '@/components/resellers/productTiers/ProductTiers.vue'
import MemberTiers from '@/components/resellers/memberTiers/MemberTiers.vue'
import { mapActions } from 'vuex'

export default {
  name: 'SetupReseller',
  components: {
    CompanyTiers,
    ProductTiers,
    MemberTiers
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    isNew: {
      type: Boolean
    },
    company: {
      type: Object,
      required: true
    },
    companyTiers: {
      type: Array,
      required: true
    },
    step: {
      type: Number,
      required: true
    },
    viaProductTiers: {
      type: Boolean
    },
    viaMemberTiers: {
      type: Boolean
    }
  },
  data() {
    return {
      isLoading: false,
      edited: 0,
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        selected: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        weight: [v => !!v || 'This field is required', v => v >= 0.1 || 'Weight should not be below 0.1 KG', v => v <= 60 || 'Weight should not be above 60 KG']
      }
    }
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    title(vm) {
      switch (this.step) {
        case 0:
          return vm.$t('set_commission')

        case 1:
          return vm.$t('set_product_commission')

        case 2:
          return vm.$t('assign_tier')

        default:
          return null
      }
    },
    disableNext() {
      return this.edited > 0
    },
    nextText(vm) {
      switch (this.step) {
        case 0:
          return vm.$t('set_commission_by_product')

        case 1:
          return vm.$t('assign_commission')

        default:
          return null
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    close() {
      this.$emit('update:step', 0)
      this.$router.replace({ query: null }).catch(() => {})
      this.showModal = false
    },
    async nextStep() {
      switch (this.step) {
        case 0:
          if (!this.$refs.companyTiers.$refs.form.validate()) {
            return
          }
          await this.saveCompanyTiers()
          break

        case 1:
          this.$router.replace({ query: null }).catch(() => {})
          this.$emit('update:step', this.step + 1)
          break

        case 2:
          this.close()
          break

        default:
          break
      }
    },
    saveCompanyTiers() {
      this.isLoading = true
      // Prepare url, data
      const url = `/companies/${this.company.id}/tiers`
      const data = {
        enabled: false,
        tiers: [...this.$refs.companyTiers.changingTiers]
      }
      // Post request
      return this.$axios
        .post(url, data)
        .then(resp => {
          this.$emit('update:companyTiers', resp.data.tiers)
          this.$emit('update:isNew', false)
          this.$emit('update:step', this.step + 1)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
<i18n>
{
"en":{
"set_commission" :"Set commission Tier/Level",
"set_product_commission" :"Set product commissions",
"assign_tier" : "Assign tier to members",
"set_commission_by_product": "set commission by product",
"assign_commission": "assign commission"
},
"id":{
"set_commission" :"Set Komisi Tingkat/Level",
"set_product_commission" :"Set Komisi Produk",
"assign_tier" : "Tingkat Member",
"set_commission_by_product": "Set Komisi mengikut Produk",
"assign_commission": "Set Komisi"
}

}
</i18n>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.text-wrapper {
  word-break: break-word;
}
</style>